export default () => {
  // fake Drupal and attachBehaviors if Drupal is not available
  if (!Drupal.t) {
    // Prepare behavior root
    Drupal.behaviors = {};

    // Implement Drupal translate
    Drupal.t = text => text;

    document.addEventListener('DOMContentLoaded', () => {
      Drupal.attachBehaviors(document, {
        env: 'slice'
      });
    });

    Drupal.attachBehaviors = function (context = document, settings = {}) {
      for (const key in Drupal.behaviors) {
        if (Drupal.behaviors.hasOwnProperty(key) &&
            typeof Drupal.behaviors[key].attach === 'function') {
          Drupal.behaviors[key].attach(context, settings);
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./js/src/slice.js